class StockistList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  static get requiredElements () {
    return ['retail', 'online']
  }

  static get requiredExternalElements () {
    return ['trigger']
  }

  setupListeners () {
    super.setupListeners()

    this.onClick = this.onClick.bind(this)

    this.externalEls.trigger.elements.forEach(el => {
      this.listeners.add(el, 'click', this.onClick)
    })
  }

  onClick (e) {
    this.hideAll()

    const typeToReveal = e.target.getAttribute('data-type')

    if (typeToReveal) {
      this.els[typeToReveal].elements.forEach(el => {
        el.classList.add('st-Stockist_Visible')
      })

      e.target.classList.add('st-Store_LinkActive')
    }
  }

  // Hide all store images and details.
  hideAll () {
    this.els.retail.elements.forEach(el => {
      el.classList.remove('st-Stockist_Visible')
    })

    this.els.online.elements.forEach(el => {
      el.classList.remove('st-Stockist_Visible')
    })

    this.externalEls.trigger.elements.forEach(el => {
      el.classList.remove('st-Store_LinkActive')
    })
  }
}

if (!customElements.get('stockist-list')) {
  customElements.define('stockist-list', StockistList)
}
